<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data () {
    return {
      cachedViews: [],
    };
  },
  computed: {
    key () {
      if (this.$route.meta.keepAlive) {
        if (this.cachedViews.indexOf(this.$route.name) == -1) {
          this.cachedViews.push(this.$route.name);
        }
      }
      return this.$route.path;
    }
  },
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  height: calc(100vh - 155px);
  width: calc(100% - 19px);
  position: relative;
  overflow: hidden;
  background: #f4f7fe;
}

@media screen and (max-width: 992px) {
  .app-main {
    padding: 14px;
  }
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
